import React, { useRef, useEffect, useState, forwardRef, useImperativeHandle, } from 'react';
import { Grid, Button, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField } from '@mui/material';

import { DefaultCard } from "../../assets/styled-components/card";
import CustomTextField from "../commoncomponents/CustomTextField";
import { jsPDF } from "jspdf";
import html2pdf from 'html2pdf.js';
import "../commoncomponents/print.css";
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';
import { useNavigate } from "react-router";
import reportslogo from "../../assets/images/reportslogo.png";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";
import { ifacSecurityURL } from "../../utility/apiURLS";
import axios from "axios";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const Printfile = forwardRef((props, ref) => {
  const { reportData, setText, text, date, setDate } = props;
  const printRef = useRef();
  const navigate = useNavigate();
  // const [text, setText] = useState("");
  const [companyName, setCompanyName] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const facilityId = getFacilityId('facilityId');
  const [name, setName] = useState(""); // State to hold the input value
  const [type, setType] = useState("");

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGA003");
  const companyId = getcompanyId('companyId');
  const token = getAuthToken("id_token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const paragraphRef = useRef(null);
  const handleInput = (field) => (event) => {
    let newText = event.target.value;

    // Limit to 500 words
    let words = newText.trim().split(/\s+/);
    if (words.length > 500) {
      words = words.slice(0, 500);
      newText = words.join(" ");
    }

    // Update the state
    setText((prev) => ({
      ...prev,
      [field]: newText,
    }));
  };

  const handleText = (field, value) => {
    setDate((prev) => ({ ...prev, [field]: value }));
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  

  const handleDownloadPDF = () => {
    const textareas = document.querySelectorAll("textarea");
    if (!textareas.length) return;

    const replacements = [];

    textareas.forEach((textarea) => {
      const tempDiv = document.createElement("div");
      tempDiv.style.cssText = `
        width: ${textarea.clientWidth}px;
        height: ${textarea.clientHeight}px;
        overflow-wrap: break-word;
        white-space: pre-wrap;
        padding: 5px;
      `;
      tempDiv.innerHTML = textarea.value.replace(/\n/g, "<br>"); // Preserve line breaks
      textarea.parentNode.replaceChild(tempDiv, textarea);
      replacements.push({ tempDiv, textarea });
    });

    // Proceed with PDF generation
    const input = printRef.current;
    const options = {
      margin: 10,
      filename: "Condition_Appraisal_Report.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        scale: 3,
        useCORS: true,
        allowTaint: false,
        logging: false,
        scrollX: 0,
        scrollY: 0,
        backgroundColor: null,
      },
      jsPDF: {
        unit: "mm",
        format: "a3",
        orientation: "portrait",
      },
      pagebreak: {
        mode: ["avoid-all", "css", "legacy"],
        overflow: "linebreak",
      },
    };

    html2pdf()
      .from(input)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          const x = pdf.internal.pageSize.getWidth() / 2;
          const y = pdf.internal.pageSize.getHeight() - 10;
          pdf.text(`Page ${i} of ${totalPages}`, x, y, { align: "center" });
        }
      })
      .save()
      .then(() => {
        // Restore textareas after PDF download
        replacements.forEach(({ tempDiv, textarea }) => {
          tempDiv.parentNode.replaceChild(textarea, tempDiv);
        });
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };




  const handleClose = () => {
    props.setOpenModal(false);
  };
  useImperativeHandle(ref, () => ({
    handleDownloadPDF,
  }));


  useEffect(() => {
    const today = new Date();
    const formattedDate = formatDate(today);
    setCurrentDate(formattedDate);
  }, []);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };
  const fetchOptions = async () => {
    try {
      const companysResponse = await axios.get(`${ifacSecurityURL}/api/seccompanyregisters/${companyId}`, config);
      setCompanyName(companysResponse.data.companyname);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    if (companyId) {
      fetchOptions();
    }
  }, [companyId]); // Only calls fetchOptions when companyId is set

  return (
    <DefaultCard
      sx={{
        mt: { xs: 1, sm: 2 }, // Margin top responsive
        mb: { xs: 2, sm: 3 }, // Margin bottom responsive
        ml: { xs: 1, sm: 2 }, // Margin left responsive
        mr: { xs: 1, sm: 2 }  // Margin right responsive
      }}
    >

      <Grid container justifyContent="flex-end">
        {access?.canPrint && (<>
          <Grid item>
            <Button variant='contained' onClick={handlePrint} style={{ marginRight: '8px' }}>Print</Button>
          </Grid>
          <Grid item>
            <Button variant='contained' onClick={handleDownloadPDF} style={{ marginRight: '8px' }}>Download</Button>
          </Grid>
        </>)}
        <Grid item>
          <Button variant='contained' onClick={handleClose}>Close</Button>
        </Grid>
      </Grid>


      <div id="capture" ref={printRef} className="pdf-container" >
        <table style={{ width: '100%', height: '150px', marginBottom: '20px', textAlign: 'left', borderCollapse: 'collapse', border: 0 }}>
          <tbody>
            <tr>
              <td style={{ verticalAlign: 'left', border: 0, }}>
                <img src={reportslogo} alt="logo" style={{ maxWidth: '100px', height: '95px' }} />
              </td>
            </tr>
          </tbody>
        </table>

        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '16px',
            fontFamily: 'Arial Narrow',
            textAlign: 'center',
            background: 'none',
            border: 0,
          }}
        >
          <tbody style={{ background: 'none' }}>

            <tr>
              <td style={{ fontSize: '25px', padding: '10px', background: 'none', border: 0, fontWeight: 'bold' }}>   {localStorage.getItem('FacilityName')}</td>
            </tr>


            <tr>
              <td style={{ fontSize: '20px', fontWeight: 'bold', padding: '10px', background: 'none', border: 0 }}>CONDITION APPRAISAL REPORT</td>
            </tr>


            <tr>
              <td style={{ fontSize: '20px', fontWeight: 'bold', padding: '10px', background: 'none', border: 0 }}>{currentDate}</td>
            </tr>


            <tr>
              <td style={{
                marginRight: '16px',
                fontSize: '16px',
                fontWeight: 'normal',
                color: 'white',
                backgroundColor: '#800080',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                boxSizing: 'border-box',
                padding: '3px'
              }}>

                CONDITION APPRAISAL-MOD/FM&CA/0001
              </td>
            </tr>
          </tbody>
        </table>

        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            style={{ marginTop: '20px', padding: '10px', width: '100%' }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              style={{ borderBottom: '1px solid #D3D3D3', marginBottom: '10px' }}
            >
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', textAlign: 'center', width: '33%', fontSize: '12px' }}>
                Prepared By
              </Typography>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', textAlign: 'center', width: '33%', fontSize: '12px' }}>
                Checked By
              </Typography>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', textAlign: 'center', width: '33%', fontSize: '12px' }}>
                Confirmed By
              </Typography>
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              style={{ marginTop: '10px' }}
            >
              <Box width="30%" display="flex" justifyContent="center">
                <TextField
                  fullWidth
                  variant="outlined"
                  sx={{ marginTop: '8px' }}
                  value={date.prepared}
                  onInput={(e) => handleText("prepared", e.target.value)}
                />
              </Box>
              <Box width="30%" display="flex" justifyContent="center">
                <TextField
                  fullWidth
                  variant="outlined"
                  sx={{ marginTop: '8px' }}
                  value={date.confirmed}
                  onInput={(e) => handleText("confirmed", e.target.value)}
                />
              </Box>
              <Box width="30%" display="flex" justifyContent="center">
                <TextField
                  fullWidth
                  variant="outlined"
                  sx={{ marginTop: '8px' }}
                  value={date.Checked}
                  onInput={(e) => handleText("Checked", e.target.value)}
                />
              </Box>
            </Box>

            <Box
              width="100%"
              style={{ borderTop: '1px solid #D3D3D3', marginTop: '10px' }}
            />
          </Box>
        </Paper>

        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          -<h4
            style={{
              marginBottom: '8px',
              padding: '5px',
              backgroundColor: '#ccc0da',
              fontSize: '12px',
              fontFamily: 'Arial',
              fontWeight: 'bold',
            }}
          >
            1)Executive Summary

          </h4>
          <div
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              width: "100%",
              height: "100px",
              marginRight: "10px",
              wordBreak: "break-word",
              padding: "5px",
              whiteSpace: "pre-wrap",
              overflow: "hidden", // Prevents extra scrollbars on div
            }}
          >
            <textarea
              style={{
                outline: "none",
                paddingLeft: "3px",
                fontSize: "15px",
                margin: "0",
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                width: "100%",
                height: "100%", // Ensure it stays within the div
                border: "none",
                padding: "5px",
                resize: "vertical",
                overflowY: "auto", // Enables scrolling inside textarea
              }}
              value={text.executive}
              onChange={(e) => {
                if (e.target.value.length <= 500) {
                  handleInput("executive")(e);
                }
              }}
              maxLength={500} // Ensures no more than 500 characters can be typed
            />
          </div>



        </Paper>

        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          <h4
            style={{
              marginBottom: '8px',
              padding: '5px',
              backgroundColor: '#ccc0da',
              fontSize: '12px',
              fontFamily: 'Arial',
              fontWeight: 'bold',
            }}
          >
            2) Introduction
          </h4>

          <div
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              width: "100%",
              height: "100px",
              marginRight: "10px",
              wordBreak: "break-word",
              padding: "5px",
              whiteSpace: "pre-wrap",
              overflow: "hidden", // Prevents extra scrollbars on div
            }}
          >
            <textarea
              style={{
                outline: "none",
                paddingLeft: "3px",
                fontSize: "15px",
                margin: "0",
                wordBreak: "break-word",
                whiteSpace: "pre-wrap",
                width: "100%",
                height: "100%", // Ensure it stays within the div
                border: "none",
                padding: "5px",
                resize: "vertical",
                overflowY: "auto", // Enables scrolling inside textarea
              }}
              value={text.Introduction}
              onChange={(e) => {
                if (e.target.value.length <= 500) {
                  handleInput("Introduction")(e);
                }
              }}
              maxLength={500} // Prevents users from typing more than 500 characters
            />
          </div>





        </Paper>


        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          <Typography
            variant="h6"
            gutterBottom
            style={{
              backgroundColor: '#ccc0da',
              padding: '5px',
              fontSize: '12px',
              fontFamily: 'Arial',
              fontWeight: 'bold',
            }}
          >
            3) Objectives
          </Typography>
          <div
            style={{
              border: "1px solid rgba(224, 224, 224, 1)",
              width: "100%",
              height: "100px",
              marginRight: "10px",
              wordBreak: "break-word",
              padding: "5px",
              whiteSpace: "pre-wrap",
              overflow: "hidden", // Prevents unnecessary scrollbars on div
            }}
          >
            <div style={{ marginBottom: "10px", color: "black" }}>
              <textarea
                style={{
                  outline: "none",
                  paddingLeft: "3px",
                  fontSize: "15px",
                  margin: "0",
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap",
                  width: "100%",
                  height: "100px",
                  border: "none",
                  padding: "5px",
                  resize: "vertical",
                  overflowY: "auto",
                }}
                value={text.Objectives}
                onChange={(e) => {
                  if (e.target.value.length <= 500) {
                    handleInput("Objectives")(e);
                  }
                }}
                maxLength={500}
              />
            </div>
          </div>


        </Paper>


        {/* Asset Details Section */}
        <Paper elevation={3} style={{ margin: '10px', padding: '9px', overflow: 'visible' }}>
          <Typography variant="h6" gutterBottom style={{ backgroundColor: '#ccc0da', fontSize: '12px', padding: '5px', fontFamily: 'Arial', fontWeight: 'bold', overflow: 'visible' }}>
            4) Asset Details
          </Typography>
          <TableContainer component={Paper} sx={{ overflow: 'visible' }}>
            <Table>
              <TableHead style={{ backgroundColor: '#daeef3', overflow: 'visible' }}>
                {/* <TableRow  sx={{overflow:'visible',padding:'5px' }}> */}
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Asset No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Asset Description</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Model</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Brand</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Make</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Purchase Cost RM</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Supplier Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Total Count of Breakdown</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', padding: '2px' }}>Total Count of PPM</TableCell>
                {/* </TableRow> */}
              </TableHead>
              <TableBody>

                <TableRow>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{props.assetNo.assetNo}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{props.assetDescription}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.model}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.brand}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.make}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.purchaseCostRM}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.supplierName}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.totalcountofBreakdown}</TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.totalcountofPPM}</TableCell>
                </TableRow>



              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Current Condition of Asset */}
        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          <Typography variant="h6" gutterBottom style={{ backgroundColor: '#ccc0da', padding: '5px', fontSize: '12px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            5) Current Condition of the Asset
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead style={{ backgroundColor: '#daeef3', fontWeight: 'bold' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Current Condition</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Asset Age (Years)</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Expected Life (Years)</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Depreciated Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell ></TableCell>
                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.assetAge}</TableCell>

                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{reportData?.expectedLife}</TableCell>

                  <TableCell style={{ textAlign: 'center', fontSize: '12px' }}> {reportData?.depreciatedValue}</TableCell>

                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Maintenance History Details */}
        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          <Typography variant="h6" gutterBottom style={{ backgroundColor: '#ccc0da', padding: '5px', fontSize: '12px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            6) Maintenance History Details
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ padding: '5px', fontWeight: 'bold', fontSize: '12px' }}
          >
            Asset/System Performance
          </Typography>
          {/* <TableContainer component={Paper}> */}
          <Table>
            <TableHead style={{ backgroundColor: '#daeef3' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Asset No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Work Order No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Work Order Date</TableCell>
                <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Work Order Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportData?.objectives?.map((objective, index, array) => {
                const isFirstInGroup = index === 0 || array[index - 1].objAssetNo !== objective.objAssetNo;
                const rowSpan = array.filter(item => item.objAssetNo === objective.objAssetNo).length;

                return (
                  <TableRow key={index}>
                    {isFirstInGroup && (
                      <TableCell rowSpan={rowSpan} style={{ textAlign: 'center', fontSize: '12px' }}>
                        {objective.objAssetNo}
                      </TableCell>
                    )}
                    <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{objective.workorderNo}</TableCell>
                    <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>
                      {new Date(objective.workorderDate).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })}
                    </TableCell>
                    <TableCell style={{ textAlign: 'center', fontSize: '12px' }}>{objective.workorderType}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {/* </TableContainer> */}

        </Paper>

        {/* Root Cause */}
        <Paper elevation={3} style={{ margin: '20px', padding: '10px' }}>
          <Typography variant="h6" gutterBottom style={{ backgroundColor: '#ccc0da', padding: '5px', fontSize: '12px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            Root Cause
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead style={{ backgroundColor: '#daeef3' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Root Cause</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Further Explanation</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell >
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={{
                        marginTop: "7px",
                        paddingLeft: "3px",
                        "& fieldset": { border: "none" }, // Removes the fieldset border
                      }}
                      value={date.root}
                      onInput={(e) => handleText("root", e.target.value)}
                    /></TableCell>
                  <TableCell > <TextField
                    fullWidth
                    variant="outlined"
                    sx={{
                      marginTop: "7px",
                      paddingLeft: "3px",
                      "& fieldset": { border: "none" }, // Removes the fieldset border
                    }}
                    value={date.futhur}
                    onInput={(e) => handleText("futhur", e.target.value)}
                  /></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Technical Advice and Proposal */}
        <Paper elevation={3} style={{ margin: '20px', padding: '10px', fontSize: '15px', fontFamily: 'Arial', fontWeight: 'bold' }}>
          <Typography variant="h6" gutterBottom style={{ backgroundColor: '#ccc0da', padding: '5px', fontSize: '12px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            7) Technical Advice and Proposal
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead style={{ backgroundColor: '#daeef3' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Technical Advice</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Proposal Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '12px' }}>Additional Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell >
                    <TextField
                      fullWidth

                      variant="outlined"
                      sx={{
                        marginTop: "7px",
                        paddingLeft: "3px",
                        "& fieldset": { border: "none" }, // Removes the fieldset border
                      }}
                      value={date.Technical}
                      onInput={(e) => handleText("Technical", e.target.value)}
                    />
                    {/* <span contentEditable="true" style={{ outline: 'none', paddingLeft: '3px' }} ></span> */}
                  </TableCell>
                  <TableCell >
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={{
                        marginTop: "7px",
                        paddingLeft: "3px",
                        "& fieldset": { border: "none" }, // Removes the fieldset border
                      }}
                      value={date.Proposal}
                      onInput={(e) => handleText("Proposal", e.target.value)}
                    /></TableCell>
                  <TableCell >
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={{
                        marginTop: "7px",
                        paddingLeft: "3px",
                        "& fieldset": { border: "none" }, // Removes the fieldset border
                      }}
                      value={date.Additional}
                      onInput={(e) => handleText("Additional", e.target.value)}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {/* Footer for Signatures */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ margin: '20px', padding: '10px', fontSize: '11px' }}
        >
          <Box width="30%" sx={{ fontSize: '11px', mt: 2 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '11px' }}>Prepared By</Typography>
            
            <TextField
              fullWidth
              variant="outlined"
              sx={{ marginTop: '8px' }}
              value={date.preparedby}
              onInput={(e) => handleText("preparedby", e.target.value)}
            />
          </Box>
          <Box width="30%" sx={{ fontSize: '11px', mt: 2 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '11px' }}>Checked By</Typography>
            <TextField
              fullWidth
              variant="outlined"
              sx={{ marginTop: '8px' }}
              value={date.checkedby}
              onInput={(e) => handleText("checkedby", e.target.value)}
            />
          </Box>
          <Box width="30%" sx={{ fontSize: '11px', mt: 2 }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '11px' }}>Confirm By</Typography>
            <TextField
              fullWidth
              variant="outlined"
              sx={{ marginTop: '8px' }}
              value={date.confirmedby}
              onInput={(e) => handleText("confirmedby", e.target.value)}
            />

          </Box>


        </Box>

      </div>

    </DefaultCard>
  );
});

export default Printfile;
